import { ParagonColors } from '@paragon/client-tools';

export const freePlanColor = ParagonColors.green;
export const estimatorPlanColor = ParagonColors.purple;
export const designerPlanColor = ParagonColors.blue;
export const upgradePlanColorGradient = `linear-gradient(to right, ${estimatorPlanColor}, ${designerPlanColor})`;
